import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CategoryImpact } from 'app/model/redshift/impact-report/category-impact';
import { ChannelImpact } from 'app/model/redshift/impact-report/channel-impact';
import { StoreImpact } from 'app/model/redshift/impact-report/store-impact';
import { createEmptySave, SavedReports } from 'app/model/redshift/saved-reports';
import { SeamRequestMeta } from 'app/model/seam/seam-request-meta';
import { SeamRequest } from 'app/model/seam-request';
import { RestfulApiService } from 'app/services/restful-api.service';

class ImpactReportService extends RestfulApiService<CategoryImpact | ChannelImpact | StoreImpact> {
    public getSavedEvidence(parent: SeamRequest, prod: boolean): Observable<SavedReports> {
        return this.http
            .get<SeamRequestMeta<SavedReports> | undefined>(`${this.getAlterUrl(parent)}/saved`, { params: { prod } })
            .pipe(map((data) => (data ? data.data : createEmptySave())));
    }

    public saveEvidence(
        evidence: SavedReports,
        parent: SeamRequest,
        prod: boolean,
    ): Observable<SeamRequestMeta<SavedReports>> {
        return this.http.post(this.getAlterUrl(parent), { evidence }, { params: { prod } });
    }

    protected getFormName(): string {
        return 'impact_report';
    }

    protected getPath(): string {
        return 'qa/impact';
    }
}

export const seamImpactReportService = new ImpactReportService();
